export default __webpack_public_path__ + "static/media/arrow-left.a25accf1.svg";